import { VisibilityOffOutlined } from '@mui/icons-material';
import { ListItemIcon, ListItemText } from '@mui/material';

import { graphql, type DocumentType } from '@/gql';

import { useMutation } from '@/hooks/mutationWithSnackbar';

import { MaybeUsableMenuItem } from './MaybeUnusableMenuItem';

const DISABLE_DOWNLOAD_OF_FILE_MUTATION = graphql(`
  mutation DisableDownloadOfFile($data: DisableDownloadOfFileInput) {
    disableDownloadOfFile(params: $data) {
      file {
        ...fileFields
      }
    }
  }
`);

const DISABLE_DOWNLOAD_OF_FILE_FILE_FRAGMENT = graphql(`
  fragment disableDownloadOfFileFileFields on File {
    ...fileFields
  }
`);

interface Props {
  file: DocumentType<typeof DISABLE_DOWNLOAD_OF_FILE_FILE_FRAGMENT>;
  canPreventDownload: boolean;
  canPreventDownloadRoot: boolean;
  unusableExplanation: string | null;
  onClose: () => void;
}

export const DisableDownloadOfFileMenuItem = ({
  file,
  canPreventDownload,
  canPreventDownloadRoot,
  unusableExplanation,
  onClose,
}: Props) => {
  const [disableDownloadOfFile] = useMutation(
    DISABLE_DOWNLOAD_OF_FILE_MUTATION,
    {
      onCompleted: onClose,
      optimisticResponse: {
        disableDownloadOfFile: {
          __typename: 'DisableDownloadOfFileResult',
          file: {
            ...file,
            preventDownload: true,
          },
        },
      },
    },
  );

  return (
    <MaybeUsableMenuItem
      isUsable={canPreventDownload}
      isExpectedUsable={canPreventDownloadRoot}
      unusableExplanation={unusableExplanation}
      onClick={() => {
        onClose();
        disableDownloadOfFile({ variables: { data: { file: file._id } } });
      }}
    >
      <ListItemIcon>
        <VisibilityOffOutlined />
      </ListItemIcon>
      <ListItemText primary="Disable Downloading" />
    </MaybeUsableMenuItem>
  );
};
